import { render, staticRenderFns } from "./SalabamShop.vue?vue&type=template&id=04e8846e&scoped=true"
import script from "./SalabamShop.vue?vue&type=script&lang=js"
export * from "./SalabamShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e8846e",
  null
  
)

export default component.exports